// extracted by mini-css-extract-plugin
export default {"container":"Content_container__dEswX","image":"Content_image__31Ult"};